import { Fragment } from "react/jsx-runtime";

export const BasicTooltipSubTitle = [
  {
    text: "Use the ",
    code: "data-bs-title",
  },
  {
    text: " to change tooltip title and ",
    code: "data-bs-toggle",
  },
  {
    text: " to add tooltip attribute.",
  },
];

export const ColoredTooltipSubTitle = [
  {
    text: "Use the ",
    code: "btn- *",
  },
  {
    text: " to change dark background color and ",
    code: "data-bs-placement='*' ",
  },
  {
    text: "to tooltip positions change.",
  },
];

export const LightTooltipsSubTitle = [
  {
    text: "Use the ",
    code: "button-light- *",
  },
  {
    text: " to change dark background color and ",
    code: "data-bs-placement='*' ",
  },
  {
    text: "to tooltip positions change.",
  },
];

export const TooltipDirectionSubTitle = [
  {
    text: "Use the ",
    code: "btn- *",
  },
  {
    text: " to change dark background color and",
    code: " data-bs-placement='*'",
  },
  {
    text: "[top/right/bottom/left] to tooltip direction change.",
  },
];

export const HtmlTooltipSubTitle = [
  {
    text: "Use the ",
    code: "bg-*-light",
  },
  {
    text: " to change light background color and ",
    code: "data-bs-title ",
  },
  {
    text: " to the content under the HTML tag.",
  },
];

export const FilledTooltipSubTitle = [
  {
    text: "Tooltip in hover effect through fill dark color.",
    code: "[.btn-outline-*]",
  },
  {
    text: ". and",
    code: "data-bs-title ",
  },
  {
    text: "to the content under the HTML Tag.",
  },
];

export const DisabledTooltipSubTitle = [
  {
    text: "Elements with the disabled attribute aren't interactive, meaning users cannot focus, hover, or click them to trigger a tooltip (or popover). ideally made keyboard-focusable using",
    code: ' tabindex= "0" .',
  },
];

export const SVGTooltipsSubtitle = [
  {
    text: "Use ",
    code: "bg-light-* ",
  },
  {
    text: "to change light background color and ",
    code: "stroke-* ",
  },
  {
    text: "to change SVG colors. ",
  },
];

export const OutlineSVGTooltipsSubTitle = [
  {
    text: "Use the ",
    code: "btn-outline-* ",
  },
  {
    text: "class to alter the outline's color, and you can position the tooltip in any swing.",
  },
];

export const ColorTooltipData = [
  {
    class: "primary",
    text: "Primary",
  },
  {
    class: "secondary",
    text: "Secondary",
  },
  {
    class: "success",
    text: "Success",
  },
  {
    class: "warning",
    text: "Warning",
  },
  {
    class: "danger",
    text: "Danger",
  },
  {
    class: "info",
    text: "info",
  },
];

export const TooltipPosition = [
  {
    class: "primary",
    position: "top",
  },
  {
    class: "secondary",
    position: "right",
  },
  {
    class: "success",
    position: "bottom",
  },
  {
    class: "warning",
    position: "left",
  },
];

export const HtmlTooltipData = [
  {
    class: "primary",
    text: "Notifications Received",
    tooltip: (
      <Fragment>
        <em>Thank</em> <u>you</u>
      </Fragment>
    ),
  },
  {
    class: "warning",
    text: "Last Warning",
    tooltip: (
      <Fragment>
        <b>Thank</b> <em>you</em>
      </Fragment>
    ),
  },
  {
    class: "danger",
    text: "It's Danger",
    tooltip: (
      <Fragment>
        <em>Thank</em> <u>you</u>
      </Fragment>
    ),
  },
  {
    class: "info",
    text: "Coming soon",
    tooltip: (
      <Fragment>
        <b>Thank</b> <em>you</em>
      </Fragment>
    ),
  },
];

export const FlippedTooltipData = [
  {
    class: "primary",
    text: "Tooltip Primary",
  },
  {
    class: "secondary",
    text: "Tooltip Secondary",
  },
  {
    class: "success",
    text: "Tooltip Success",
  },
  {
    class: "info",
    text: "Tooltip Info",
  },
];

export const SVGTooltipsData = [
  {
    class: "info",
    text: "Notification",
    icon: "email-box",
  },
  {
    class: "secondary",
    text: "Like",
    icon: "stroke-bookmark",
  },
  {
    class: "success",
    text: "Comment",
    icon: "stroke-msg",
  },
  {
    class: "primary",
    text: "Share",
    icon: "stroke-button",
  },
];

export const OutlineSVGTooltipsData = [
  {
    class: "primary",
    text: "Notification",
    icon: <i className="icofont icofont-envelope"></i>,
  },
  {
    class: "danger",
    text: "Message",
    icon: <i className="icofont icofont-ui-text-loading"></i>,
  },
  {
    class: "primary",
    text: "Send",
    icon: <i className="icofont icofont-location-arrow"></i>,
  },
  {
    class: "danger",
    text: "Like",
    icon: <i className="icofont icofont-heart-alt"></i>,
  },
];
